module.exports = __webpack_public_path__ + "static/TripleThreat-fb1183bc8f8ef152ca66df9e6241580f.jpg";